import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./accountlayout.css";

function AccountMenu() {
    const navigate = useNavigate();
    const location = useLocation();

    const isOrdersActive = location.pathname.startsWith("/account/orders");
    const isAddressesActive = location.pathname.startsWith("/account/addresses");
    const isWishlistActive = location.pathname.startsWith("/account/wishlist");

    return (
        <div className="mobile-sidebar-page">
            <div className="sidebar">
                <div className="account-title">
                    <p>Account</p>
                    <p>{localStorage.getItem("name")}</p>
                </div>

                <div
                    className={isOrdersActive ? "active" : ""}
                    onClick={() => navigate("/account/orders")}
                >
                    <Link to="/account/orders" onClick={(e) => e.stopPropagation()}>
                        Orders
                    </Link>
                </div>
                <div
                    className={isAddressesActive ? "active" : ""}
                    onClick={() => navigate("/account/addresses")}
                >
                    <Link to="/account/addresses" onClick={(e) => e.stopPropagation()}>
                        Address
                    </Link>
                </div>
                <div
                    className={isWishlistActive ? "active" : ""}
                    onClick={() => navigate("/account/wishlist")}
                >
                    <Link to="/account/wishlist" onClick={(e) => e.stopPropagation()}>
                        Wishlist
                    </Link>
                </div>
                <div onClick={() => navigate("/logout")}>
                    <Link to="/logout" onClick={(e) => e.stopPropagation()}>
                        Logout
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default AccountMenu;
